module.exports = __webpack_public_path__ + "img/utnacunova.963ecdfd.jpg";